import request from "@js/web/request/Axios";

// login
export const apiLogin = (
  data: pro.yunpb.IAccountLoginReq = {}
): Promise<pro.yunpb.IAccountLoginRes> => {
  return request({
    reqDesction: "AccountLoginReq",
    resDesction: "AccountLoginRes",
    funcName: "Login",
    serverName: "chikii.auth.AuthExtObj",
    data,
  });
};

// loginout
export const apiLoginout = (
  data: pro.yunpb.ILogoutReq = {}
): Promise<pro.yunpb.ILogoutRes> => {
  return request({
    reqDesction: "LogoutReq",
    resDesction: "LogoutRes",
    funcName: "Logout",
    serverName: "chikii.userstatus.UserStatusExtObj",
    data,
  });
};

// 获取金币
export const apiGetMoney = (
  data: pro.yunpb.IAssetsMoneyReq = {}
): Promise<pro.yunpb.IAssetsMoneyRes> => {
  return request({
    reqDesction: "AssetsMoneyReq",
    resDesction: "AssetsMoneyRes",
    funcName: "GetMoney",
    serverName: "chikii.assets.AssetsExtObj",
    data,
  });
};

// 获取宝石
export const apiGetBagItems = (
  data: pro.yunpb.IGetBagItemsReq = {}
): Promise<pro.yunpb.IGetBagItemsRes> => {
  return request({
    reqDesction: "GetBagItemsReq",
    resDesction: "GetBagItemsRes",
    funcName: "GetBagItems",
    serverName: "chikii.assets.AssetsExtObj",
    data,
  });
};

// 获取用户信息
export const apiGetPlayer = (
  data: pro.yunpb.IPlayerReq = {}
): Promise<pro.yunpb.IPlayerRes> => {
  return request({
    reqDesction: "PlayerReq",
    resDesction: "PlayerRes",
    funcName: "GetPlayer",
    serverName: "chikii.user.UserExtObj",
    data,
  });
};

// 获取用户钱包
export const apiCheckUserWallet = (
  data: pro.yunpb.ICheckUserWalletReq
): Promise<pro.yunpb.ICheckUserWalletRes> => {
  return request({
    reqDesction: "CheckUserWalletReq",
    resDesction: "CheckUserWalletRes",
    funcName: "CheckUserWallet",
    serverName: "chikii.user.UserExtObj",
    data,
  });
};

// 获取当前游戏时长
export const apiGetRemainderGold = (
  data: pro.yunpb.IRemainderGoldReq
): Promise<pro.yunpb.IRemainderGoldRes> => {
  return request({
    reqDesction: "RemainderGoldReq",
    resDesction: "RemainderGoldRes",
    funcName: "GetRemainderGold",
    serverName: "chikii.user.UserExtObj",
    data,
    useSocket: true,
  });
};

//获取会员界面信息
export const apiGetVipPageInfo = (
  data: pro.yunpb.IGetVipPageInfoReq
): Promise<pro.yunpb.IGetVipPageInfoRes> => {
  return request({
    reqDesction: "GetVipPageInfoReq",
    resDesction: "GetVipPageInfoRes",
    funcName: "GetVipPageInfo",
    serverName: "chikii.store.StoreExtObj",
    data,
    useSocket: true,
  });
};
//获取邮箱验证码
export const apiGetMailCode = (
  data: pro.yunpb.IGetMailCodeReq
): Promise<pro.yunpb.IGetMailCodeRes> => {
  return request({
    reqDesction: "GetMailCodeReq",
    resDesction: "GetMailCodeRes",
    funcName: "GetMailCode",
    serverName: "chikii.mail.MailExtObj",
    data,
  });
};

//获取邮箱验证码
export const apiVerifyMailCode = (
  data: pro.yunpb.IVerifyMailCodeReq
): Promise<pro.yunpb.IVerifyMailCodeRes> => {
  return request({
    reqDesction: "VerifyMailCodeReq",
    resDesction: "VerifyMailCodeRes",
    funcName: "VerifyMailCode",
    serverName: "chikii.mail.MailExtObj",
    data,
  });
};
